import React from "react";

const FOCUSABLE = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[role='button']",
  "[role='link']",
].join(",");

type Props = {
  targetId?: string;
  label?: string;
  className?: string;
  focusFirstInteractive?: boolean;
};

export function SkipLink({
  targetId = "main-content",
  label = I18N("aria::Zum Inhalt springen"),
  className = "skip-link",
  focusFirstInteractive = false,
}: Props) {
  const onActivate = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Ein Tick warten, damit der Browser den Hash-Jump & Fokus erledigt
    requestAnimationFrame(() => {
      const el = document.getElementById(targetId) as HTMLElement | null;
      if (!el) return;

      history.replaceState(null, "", window.location.pathname + window.location.search);
      if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
      const first = focusFirstInteractive ? el.querySelector<HTMLElement>(FOCUSABLE) : null;
      (first ?? el).focus({ preventScroll: true });
      el.scrollIntoView({ block: "start" });

      // Safari/Firefox-Edgecase: noch einen Frame später erneut fokussieren
      requestAnimationFrame(() => (first ?? el).focus({ preventScroll: true }));
    });
  };

  return (
    <a href={"#" + targetId} className={className} onClick={onActivate}>
      {label}
    </a>
  );
}
